import { EdgeInput, InputContainer, Label } from "./styles";

const IterableEdges = ({ number, edges, setEdges, item, onInputSelect }) => {
  const handleInputChange = (event) => {
    handleSetEdges(event.target.value, item.id);
  };

  const handleSetEdges = (e, id) => {
    const newEdges = edges.map((edge) =>
      edge.id === id ? (edge = { ...edge, text: e }) : edge
    );
    return setEdges(newEdges);
  };

  return (
    <InputContainer>
      <Label>Escolha {number + 1}</Label>
      <EdgeInput
        type="text"
        value={item.text.toUpperCase()}
        onChange={handleInputChange}
        onFocus={onInputSelect}
      />
    </InputContainer>
  );
};

export default IterableEdges;
/*
onChange={(e) => {
  e.preventDefault();
  const pointer = e.target.selectionStart;

  window.requestAnimationFrame(() => {
    e.target.selectionStart = pointer;
    e.target.selectionEnd = pointer;
  });
  setText(e.target.value.toUpperCase());
}}*/
